import sale from "../assets/138213.svg";
import rent from "../assets/998220.svg";
import exchange from "../assets/994393.svg";
import donation from "../assets/940817.svg";
import auction from "../assets/venta-renta.svg";

export const AD_KIND_OPTIONS = [
  { slug: "sale", kindCommerceId: 2, labelKey: "sale", image: sale },
  { slug: "rent", kindCommerceId: 4, labelKey: "rent", image: rent },
  { slug: "exchange", kindCommerceId: 3, labelKey: "exchange", image: exchange },
  { slug: "donation", kindCommerceId: 1, labelKey: "donation", image: donation },
  { slug: "auction", kindCommerceId: 5, labelKey: "auction", image: auction },
];
